import { render, staticRenderFns } from "./ReadBook.vue?vue&type=template&id=012ff924&scoped=true&"
import script from "./ReadBook.vue?vue&type=script&lang=js&"
export * from "./ReadBook.vue?vue&type=script&lang=js&"
import style0 from "./ReadBook.vue?vue&type=style&index=0&id=012ff924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ff924",
  null
  
)

component.options.__file = "ReadBook.vue"
export default component.exports